import { useHistory } from 'react-router-dom';

/**
 * Updates the browser URL with CSV-encoded filters
 * @param queryParams
 * @returns {(function({}=): void)|*}
 */
export const useUpdateUrlWithFilters = (queryParams) => {
    const history = useHistory();

    return (filters) => {
        const updatedParams = new URLSearchParams(queryParams);

        Object.entries(filters).forEach(([key, value]) => {
            if (!value || value.length === 0) {
                updatedParams.delete(key);
            } else {
                updatedParams.set(key, value.join(','));
            }
        });

        history.push({
            pathname: window.location.pathname,
            search: `?${updatedParams.toString()}`
        });
    };
};
